// FIXME: Update this configuration file based on your project information
export const AppConfig = {
  name: 'Mittal Ventures',
  url: 'https://www.mittalvc.com',
  vercelUrl: '',
  phone: '',
  email: '',
};
